<template>
  <div class="bg-blue clearfix">
    <div class="container-fluid">
      <div class="row d-flex justify-content-center ">
        <div class="col-11 col-md-5 mx-auto py-5">
          <u-animate-container>
            <u-animate
              name="fadeInUp"
              delay="0s"
              duration="1s"
              :iteration="1"
              :offset="-50"
              animateClass="animated"
              :begin="false"
            >
            <div class="logo">
              <RTEdgarLogo class="rte-logo" />
            </div>

            <p class="col-white">
              10 Wallace Avenue Toorak, Victoria 3142 <br />
              +61 3 9826 1000
            </p>
            </u-animate>
          </u-animate-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RTEdgarLogo from '@/assets/core/rte-logo.svg';

export default {

  name: 'AddressAndInfo',
  components: {
    RTEdgarLogo,
  },
  data() {
    return {
      heading: '',
      description: '',
    }
  },
  created() {
    this.heading = this.$store.getters.getHeading
    this.description = this.$store.getters.getDescription
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .rte-logo {
    width: 200px;
    margin-bottom: 30px;
    svg {
      width: 100%;
    }
  }
</style>
